import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Icon from 'bundles/internal-ui/components/icon/Icon';
import type { Action, Column } from 'bundles/internal-ui/components/table/types';

type Props = {
  columns: Array<Column>;
  actions?: Array<Action>;
  onHeaderCellClick: (sortColumn: string, sortDescending: boolean) => void;
  sortColumn?: string;
  sortDescending?: boolean;
  isSortToggleEnabled?: boolean;
};

class TableHeader extends React.Component<Props> {
  static propTypes = {
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        onClick: PropTypes.func,
      })
    ),
    onHeaderCellClick: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDescending: PropTypes.bool,
    isSortToggleEnabled: PropTypes.bool,
  };

  renderAction() {
    if (this.props.actions) {
      return (
        <th className="action" style={{ width: this.props.actions.length * 60 }}>
          Actions
        </th>
      );
    }
  }

  renderHeaderCell = (column: Column) => {
    const { sortColumn, sortDescending, isSortToggleEnabled, onHeaderCellClick } = this.props;
    const isCurrentSortColumn = column.key === sortColumn;
    if (isSortToggleEnabled) {
      const headerCellClass = classNames('clickable-cell', {
        'sorted-column-header': isCurrentSortColumn,
      });
      if (isCurrentSortColumn) {
        return (
          <th
            key={column.key}
            style={{ width: column.width }}
            onClick={() => onHeaderCellClick(column.key, !sortDescending)}
            className={headerCellClass}
          >
            {column.name}
            <Icon name={sortDescending ? 'arrow_drop_down' : 'arrow_drop_up'} />
          </th>
        );
      } else {
        return (
          <th
            key={column.key}
            style={{ width: column.width }}
            onClick={() => onHeaderCellClick(column.key, true)}
            className={headerCellClass}
          >
            {column.name}
          </th>
        );
      }
    } else {
      return (
        <th key={column.key} style={{ width: column.width }}>
          {column.name}
        </th>
      );
    }
  };

  render() {
    const { columns } = this.props;
    const nonTooltipColumns = columns.filter((column) => column.type !== 'tooltip');
    return (
      <thead>
        <tr>
          {nonTooltipColumns.map((column) => this.renderHeaderCell(column))}
          {this.renderAction()}
        </tr>
      </thead>
    );
  }
}

export default TableHeader;
